/**
 * KarnoffelMusicGate — keeps the Bach French Suite C-minor loop
 * playing for as long as the visitor is on ANY /games/karnoffel page,
 * and stops it the moment they navigate away.  Mounted once at the
 * App root so the audio survives client-side route changes between
 * sibling Karnöffel pages.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { startKarnoffelMusic, stopKarnoffelMusic } from "@/lib/karnoffelMusic";

export default function KarnoffelMusicGate() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/games/karnoffel")) {
      startKarnoffelMusic();
    } else {
      stopKarnoffelMusic();
    }
  }, [pathname]);
  useEffect(() => () => stopKarnoffelMusic(), []);
  return null;
}
